import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  uploadLimitDb,
  uploadManufacturerDb,
  uploadDeviceSoftware,
  uploadfiberfiles,
  uploadAdapterPolicy,
  getUploadLog
} from '../../redux/actions'

import Settings from '../../components/settings'

class SettingsPage extends Component {

  render() {

    const {
      translate,
      uploadLimitDb,
      uploadManufacturerDb,
      uploadDeviceSoftware,
      uploadfiberfiles,
      uploadAdapterPolicy,
      log
    } = this.props

    return (
      <Settings translate={translate}
        uploadLimitDb={uploadLimitDb}
        uploadManufacturerDb={uploadManufacturerDb}
        uploadDeviceSoftware={uploadDeviceSoftware}
        uploadLt4LimitDb={uploadLimitDb}
        uploadAdapterPolicy={uploadAdapterPolicy}
        uploadFiberFilesDb={uploadfiberfiles}
        log={log}
      />
    )
  }
  componentWillMount() {
    this.props.getUploadLog()
  }

}

const mapDispatchToProps = (dispatch, props) => ({
  uploadLimitDb: (data) => dispatch(uploadLimitDb(data)),
  uploadManufacturerDb: (data) => dispatch(uploadManufacturerDb(data)),
  uploadDeviceSoftware: (data) => dispatch(uploadDeviceSoftware(data)),
  getUploadLog: () => dispatch(getUploadLog()),
  uploadAdapterPolicy: (data) => dispatch(uploadAdapterPolicy(data)),
  uploadfiberfiles: (data) => dispatch(uploadfiberfiles(data))
})

const mapStateToProps = (state) => ({
  log: state.settingReducer.log
})

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage)
